import { GoalSetterModalLauncher } from '@blocks';

export const ActivityModalLauncher = () => <GoalSetterModalLauncher />;
